import React, { createContext, useContext, useState, useCallback } from 'react';
import CssLoader from '@shared/components/CssLoader';

const LoadingContext = createContext();

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('Loading...');

  const startLoading = useCallback((message = 'Loading...') => {
    setLoadingMessage(message);
    setLoading(true);
  }, []);

  const stopLoading = useCallback(() => {
    setLoading(false);
    setLoadingMessage('Loading...');
  }, []);

  const value = {
    loading,
    loadingMessage,
    startLoading,
    stopLoading,
  };

  return (
    <LoadingContext.Provider value={value}>
      {children}
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            backdropFilter: 'blur(8px)',
            padding: '1rem 2rem',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          <CssLoader size={35} data-testid="loader" />
          <p
            style={{
              margin: 0,
              marginLeft: '1rem',
              color: '#374151',
              fontSize: '0.95rem',
              fontWeight: 500,
            }}
          >
            {loadingMessage}
          </p>
        </div>
      )}
    </LoadingContext.Provider>
  );
};
